import { render, staticRenderFns } from "./WeekSymptoms.vue?vue&type=template&id=79327f74"
import script from "./WeekSymptoms.vue?vue&type=script&lang=js"
export * from "./WeekSymptoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports